<template>
    <div class="condition-content">
        <compare-selector
            ref="selector"
            :valid="valid"
            :value="currentValue"
            :multiple="true"
            type="SESSION_TYPE"
            :options="options"
            :placeholder="$t('请选择会话通路')"
            @change="onChange"
        />
    </div>
</template>

<script>
import checkChannel from '@/utils/checkChannel';
import CompareSelector from './plugins/compare-selector';
import dataSource from './plugins/compare-selector/config';

export default {
  name: 'SessionChannel',

  components: {
    CompareSelector,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    dataSource: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    const currentValue = this.value || [];
    return {
      currentValue,
      valid: true,
    };
  },
  computed: {
    brief() {
      const selectText = this.$refs.selector.currentOptions
        .filter(obj => this.currentValue.indexOf(obj.value) > -1)
        .map(item => item.text)
        .join(',');
      return this.$t('{text}为{value}', { text: this.optionInfo.text, value: selectText });
    },
    options() {
      if (!this.dataSource) return [];
      const showIds = checkChannel.channelIdsMap(this.dataSource.data);
      const ops = dataSource.SESSION_TYPE.filter(item => showIds.indexOf(item.value) > -1);
      return ops;
    },
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue || [];
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    getValidate() {
      return !!(this.currentValue.length && this.currentValue.length > 0);
    },
    validate() {
      this.valid = this.getValidate();
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = {
        operation: 'arrayInclude',
        name: 'sessionChannel',
        type: 'array',
        value: JSON.stringify(value),
      };
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: this.getValidate(),
      });
    },
  },
};
</script>
